import React, {Component} from 'react';
import {
    Button as Button2,
    Col,
    Container,
    CustomInput,
    FormFeedback,
    FormGroup,
    FormText,
    Input,
    Label,
    Row
} from 'reactstrap';

import union from 'lodash/union'
import unionBy from 'lodash/unionBy'
import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import DateInput from "react-datepicker";
import moment from "moment";
import {DABBL_COLOR, isAlphaNumeric, isNumeric} from "../../../shared/utils";
import ColorInput from '../../../shared/components/ColorInput';


class EditVerifiedPurchase extends Component {

    constructor(props) {
        super(props);
        this.state = {
            giftCardColorValid: true,
            isUpdating: false,
            isActivating: false,
            campaign: null,
            upc: '',
            zip: '',
            error: null,
            validateForm: false
        }
    }

    componentWillMount() {
        const {receipt, giftCards} = this.props
        if (receipt) {
            const rsGroup = receipt.receiptScanGroupList && receipt.receiptScanGroupList.length > 0 && receipt.receiptScanGroupList[0].id ? receipt.receiptScanGroupList[0] : {}
            const campaign = rsGroup.campaigns && rsGroup.campaigns.length > 0 ? rsGroup.campaigns[0] : {}
            const campaignId = rsGroup.campaigns && rsGroup.campaigns.length > 0 ? rsGroup.campaigns[0].campaignId : ''
            this.setState({...receipt,
                rsgid: rsGroup.id,
                groupName: rsGroup.name,
                campaign: campaign,
                campaignId: campaignId,
                startDate: receipt.startDate ? moment(moment.utc(receipt.startDate).format('LL')).startOf('day') : moment(),
                expirationDate: receipt.expirationDate ? moment(moment.utc(receipt.expirationDate).format('LL')).startOf('day') : moment(),
                costPerCompletion: rsGroup.costPerCompletion * 1000,
                split: rsGroup.costPerCompletion ? Math.round(rsGroup.valuePerUser/rsGroup.costPerCompletion * 100) : 0,
                valuePerUser: rsGroup.valuePerUser * 1000,
                threshold: rsGroup.threshold,
                creditType: rsGroup.creditType,
                rewardType: rsGroup.giftCardId ? 'GIFTCARD' : 'POINTS',
                giftCardId: rsGroup.giftCardId,
                giftCard: giftCards.filter((c) => c.id === rsGroup.giftCardId).shift(),
                giftCardAmount: rsGroup.giftCardId ? rsGroup.valuePerUser : 0,
                giftCardColor: rsGroup.giftCardColor || DABBL_COLOR,
                maxPerUser: Number(rsGroup.maxPerUser),
                maxTotal: Number(rsGroup.maxTotal),
                productImageUrl: rsGroup.productImageUrl,
                productDescription: rsGroup.productDescription,
                priority: rsGroup.priority ? rsGroup.priority : 9,
                retailers: this.getRetailerList(rsGroup.retailers.map(r => r.name)).map((r) => ({name: r, checked: (rsGroup.retailers.length === 0) && r === 'Any' || rsGroup.retailers.find(r1 => r1.name === r)})),
                upcs: rsGroup.upcs ? rsGroup.upcs.map(u => u.upc) : [],
                zips: rsGroup.zips ? rsGroup.zips.map(u => u.zip) : [],
                fullStreetAddress: rsGroup.fullStreetAddress,
                validateForm: true});
        } else {
            this.setState({
                name: '',
                groupName: '',
                startDate: moment(),
                expirationDate:  moment(this.state.startDate).add(7, "day"),
                campaign: null,
                campaignId: '',
                costPerCompletion: 1,
                split: 100,
                valuePerUser: 1,
                threshold: 1,
                creditType: 'COUNT_THRESHOLD',
                rewardType: 'POINTS',
                giftCardId: '',
                giftCardAmount: 0,
                giftCardColor: DABBL_COLOR,
                maxPerUser: 20,
                maxTotal: 20,
                productImageUrl: '',
                productDescription: '',
                retailers: this.getRetailerList([]).map((r) => ({name: r, checked: r === 'Any'})),
                priority: 9,
                upcs: [],
                zips: [],
                fullStreetAddress: '',
            });
        }
    }

    componentDidMount(){
        const {loadCampaignsForAgency, loadGiftCards} = this.props
        loadCampaignsForAgency(this.props.agencyId).then(()=>loadGiftCards())
    }

    componentWillUpdate(newProps, newState) {
        if (!newProps.isCreate && newProps.receipt && !this.props.receipt){
            const {receipt, giftCards} = newProps
            const rsGroup = receipt.receiptScanGroupList && receipt.receiptScanGroupList.length > 0 && receipt.receiptScanGroupList[0].id ? receipt.receiptScanGroupList[0] : {}
            const campaign = rsGroup.campaigns && rsGroup.campaigns.length > 0 ? rsGroup.campaigns[0] : {}
            const campaignId = rsGroup.campaigns && rsGroup.campaigns.length > 0 ? rsGroup.campaigns[0].campaignId : ''
            this.setState({...receipt,
                rsgid: rsGroup.id,
                groupName: rsGroup.name,
                campaign: campaign,
                campaignId: campaignId,
                startDate: receipt.startDate ? moment(moment.utc(receipt.startDate).format('LL')).startOf('day') : moment(),
                expirationDate: receipt.expirationDate ? moment(moment.utc(receipt.expirationDate).format('LL')).startOf('day') : moment(),
                costPerCompletion: rsGroup.costPerCompletion * 1000,
                split: rsGroup.costPerCompletion ? Math.round(rsGroup.valuePerUser/rsGroup.costPerCompletion * 100) : 0,
                valuePerUser: rsGroup.valuePerUser * 1000,
                threshold: rsGroup.threshold,
                creditType: rsGroup.creditType,
                rewardType: rsGroup.giftCardId ? 'GIFTCARD' : 'POINTS',
                giftCardId: rsGroup.giftCardId,
                giftCard: giftCards.filter((c) => c.id === rsGroup.giftCardId).shift(),
                giftCardAmount: rsGroup.giftCardId ? rsGroup.valuePerUser : 0,
                giftCardColor: rsGroup.giftCardColor,
                maxPerUser: Number(rsGroup.maxPerUser),
                maxTotal: Number(rsGroup.maxTotal),
                productImageUrl: rsGroup.productImageUrl,
                productDescription: rsGroup.productDescription,
                priority: rsGroup.priority ? rsGroup.priority : 9,
                retailers: this.getRetailerList(rsGroup.retailers.map(r => r.name)).map((r) => ({name: r, checked: (rsGroup.retailers.length === 0) && r === 'Any' || rsGroup.retailers.find(r1 => r1.name === r)})),
                upcs: rsGroup.upcs ? rsGroup.upcs.map(u => u.upc) : [],
                zips: rsGroup.zips ? rsGroup.zips.map(u => u.zip) : [],
                fullStreetAddress : rsGroup.fullStreetAddress,
                validateForm: true,
                isCreate: false});
        }
    }

    getRetailerList(retailers) {
        return ['Any'].concat(union(retailers, ['ALDI', 'Amazon', 'Costco Wholesale Corp.', 'CVS', 'Dollar General', 'Dollar Tree', 'Family Dollar', 'Food Lion', 'Fry\'s Food and Drug', 'H-E-B', 'Kroger', 'Meijer', 'Publix Super Markets', 'Safeway', 'Sam\'s Club', 'ShopRite', 'Stop & Shop', 'Target', 'Walgreens', 'Walmart', 'Albertsons ','BJ\'s Wholesale','Cub Foods','Giant Eagle','Rite Aid','Trader Joe\'s','Wegman\'s','Whole Foods Marke']).sort())
    }

    handleNameChange(name) {
        this.setState({ name: name });
    }

    handleGroupNameChange(value) {
        this.setState({ groupName: value });
    }

    getCampaignTitle(campaign) {
        return campaign ? `${campaign.name}` : ''
    }

    handleCampaignChange(campaignId){
        const campaign = this.props.campaigns.filter((c) => c.id === campaignId).shift()
        this.setState({campaignId: campaignId, campaign: campaign});
    }

    handleGiftCardChange(giftCardId){
        const giftCard = this.props.giftCards.filter((c) => c.id === giftCardId).shift()
        // this.setState({giftCardId: giftCardId, giftCard: giftCard, giftCardAmount: this.state.giftCardAmount || giftCard.minValue});
        this.setState({giftCardId: giftCardId, giftCard: giftCard});
    }

    handleCardAmountChange(giftCardAmount){
        this.setState({giftCardAmount: giftCardAmount});
    }

    getCardTitle(card) {
        return card ? `${card.title}($${card.minValue}-$${card.maxValue})` : ''
    }

    isCardAmountValid(){
        const {giftCard, giftCardAmount} = this.state
        return !giftCard || giftCard.id && giftCardAmount && giftCard.minValue <= giftCardAmount && giftCard.maxValue >= giftCardAmount
    }

    handleCostPerCompletionChange(value){
        let costPerCompletion = Number(value) || 0
        this.setState({costPerCompletion: costPerCompletion, valuePerUser: Math.round(this.state.split * costPerCompletion / 100)});
    }

    handleSplitChange(value){
        const split = Number(value) || 0
        this.setState({split: split, valuePerUser: Math.round(split * this.state.costPerCompletion / 100)});
    }

    handleProductImageChange(image) {
        this.setState({productImageUrl: image.large});
    }

    handleRetailerSwitchChange(e){
        if (e.target.name === 'Any' && e.target.checked) {
            this.setState({retailers: this.state.retailers.map((r) => ({name: r.name, checked: r.name === 'Any'}))})
        } else {
            this.setState({retailers: this.state.retailers.map((option) => ( option.name !== e.target.name ? (option.name !== 'Any' ? option : {...option, checked: false}) : {name: option.name, checked: e.target.checked}))});
        }
    }

    handleRetailerChange(e){
        this.setState({retailers: Array.from(e.target.options).map((option) => ({name: option.value, checked: option.selected}))});
    }

    handleBudgetChange(budget) {
        this.setState({ budget: budget });
    }

    handleUpcDelete(upc){
        this.setState({upcs: this.state.upcs.filter(u => u !== upc)})
    }

    handleUpcSubmitted(e){
        const key = e.key
        const code = key.charCodeAt(0)
        if (!(code > 47 && code < 58) && // numeric (0-9)
            !(code > 64 && code < 91) && // upper alpha (A-Z)
            !(code > 96 && code < 123) // lower alpha (a-z)
            && key !== 'Enter') {
            e.preventDefault()
            return
        }
        if(key !== 'Enter') {
            return
        }
        let upc = e.target.value
        e.preventDefault();
        if (!upc || upc.length > 12 || upc.length < 10 || !isAlphaNumeric(upc) || upc.length > 10 && isNaN(upc)){
            this.setState({ upc: '' });
            return
        }
        if (upc.length === 11) {
            upc = '0' + upc
        }
        if (this.state.upcs.indexOf(upc) !== -1){
            return
        }
        this.setState({ upc: '', upcs: [...this.state.upcs, upc] });
    }

    handleUpcChange(e){
        let upc = e.target.value
        if (upc.length > 12 || isAlphaNumeric(upc) && isNaN(upc) && upc.length > 10) {
            e.preventDefault()
            return
        }
        this.setState({ upc: e.target.value })
    }

    adjustUpc(upc){
        if (!upc || upc.length > 12 || upc.length < 10 || !isAlphaNumeric(upc) || upc.length > 10 && isNaN(upc)){
            return ''
        }
        if (upc.length === 11) {
            return '0' + upc
        }
        return upc
    }
    handleZipDelete(zip){
        this.setState({zips: this.state.zips.filter(u => u !== zip)})
    }

    handleZipSubmitted(e){
        const key = e.key
        const code = key.charCodeAt(0)
        if (!(code > 47 && code < 58) // numeric (0-9)
            && key !== 'Enter') {
            e.preventDefault()
            return
        }
        if(key !== 'Enter') {
            return
        }
        const {zips} = this.state
        let zip = this.adjustZip(e.target.value)
        e.preventDefault();
        if (!zip || zip === '00000' || zips.indexOf(zip) !== -1){
            this.setState({ zip: '' });
            return
        }
        this.setState({ zip: '', zips: [...zips, zip] });
    }

    handleZipChange(e){
        let zip = e.target.value
        if (!zip || zip.length > 5 || !isNumeric(zip)) {
            e.preventDefault()
            return
        }
        this.setState({ zip: e.target.value })
    }

    adjustZip(zip){
        if (!zip || zip.length > 5 || !isNumeric(zip)){
            return ''
        }
        return ('00000' + zip).slice(-5)
    }

    handleFileUploadChange(e, handler){
        let reader = new window.FileReader();
        reader.onload = (e1) => {
            handler(reader.result)
        }
        reader.readAsText(e.target.files[0]);
        e.target.value = ''
    }

    isValidReceipt() {
        const {name, groupName, startDate, expirationDate, budget, costPerCompletion, rewardType, valuePerUser,  giftCardId, giftCardAmount, giftCardColor, giftCardColorValid, creditType, threshold, maxPerUser, maxTotal, productImageUrl,  productDescription, split, retailers, upcs} = this.state

        const selectedRetailers = retailers.filter((r) => r.checked).map((r) => r.name)
        return name && groupName && creditType && startDate < expirationDate &&
            budget &&
            (rewardType === 'POINTS' && valuePerUser >= 1 && valuePerUser <= 10000 &&
                costPerCompletion >= 1 && costPerCompletion <= 10000 &&
                split >= 1 && split <= 100 && Number(budget) * 1000 >= Number(costPerCompletion)
                || rewardType === 'GIFTCARD' && giftCardId && this.isCardAmountValid() &&
                giftCardColor && giftCardColorValid) &&
            Number.isInteger(maxPerUser) && maxPerUser > 0 &&
            Number.isInteger(maxTotal) && maxTotal > 0 &&
            threshold >= 1 && productImageUrl && productDescription &&
            !retailers.every(retailer => (!retailer.checked)) &&
            (upcs.length > 0 || upcs.length === 0 && creditType === 'AMOUNT_THRESHOLD' && selectedRetailers.length > 0 && selectedRetailers[0] !== 'Any')

    }

    handleColorChange(color) {
        const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

        if (isValid) {
            this.setState({
                giftCardColor: color,
                giftCardColorValid: isValid
            })
        } else {
            this.setState({giftCardColorValid: isValid})
        }
    }

    clearUpcs(e){
        e.preventDefault()
        this.setState({upcs: []})
    }

    handleSubmit(data) {
        console.debug("handleSubmit")
        if (!this.isValidReceipt()) {
            this.setState({validateForm: true})
            return
        }
        const receipt = this.props.receipt || {}
        const rsGroup = receipt.receiptScanGroupList && receipt.receiptScanGroupList.length > 0 ? receipt.receiptScanGroupList[0] : {}
        const prevCampaignId = rsGroup.campaigns && rsGroup.campaigns.length > 0 && rsGroup.campaigns[0].campaignId ? rsGroup.campaigns[0].campaignId : ''
        const {isCreate, loadReceiptLineups, agencyId, brandId} = this.props
        const {name, rsgid, groupName, startDate, campaignId, expirationDate, priority, budget, costPerCompletion, rewardType, giftCardId, giftCardAmount, giftCardColor, valuePerUser, maxPerUser, maxTotal, creditType, threshold, productImageUrl, productDescription, retailers, upcs, zips, fullStreetAddress} = this.state
        const valuePerUserOrGiftCardDenomination = rewardType === 'POINTS' ? Number(valuePerUser)/1000 : giftCardAmount
        const rsGroupData = {
            ...(rsgid && rsgid.length > 0 && {id: rsgid}),
            ...(groupName !== rsGroup.name && {name: groupName}),
            ...(costPerCompletion !== rsGroup.costPerCompletion * 1000 && {costPerCompletion: Number(costPerCompletion)/1000}),
            ...(valuePerUserOrGiftCardDenomination !== rsGroup.valuePerUser * 1000 && {valuePerUser: valuePerUserOrGiftCardDenomination}),
            ...((giftCardId !== rsGroup.giftCardId || rewardType === 'POINTS' && giftCardId) && {giftCardId: rewardType === 'POINTS' ? null : giftCardId}),
            ...(giftCardColor !== rsGroup.giftCardColor && {giftCardColor: giftCardColor}),
            ...(maxPerUser !== rsGroup.maxPerUser && {maxPerUser: maxPerUser}),
            ...(maxTotal !== rsGroup.maxTotal && {maxTotal: maxTotal}),
            ...(creditType !== rsGroup.creditType && {creditType: creditType}),
            ...(threshold !== rsGroup.threshold && {threshold: threshold}),
            ...(campaignId !== prevCampaignId && {campaigns: campaignId ? [{campaignId: campaignId}] : []}),
            ...(productImageUrl !== rsGroup.productImageUrl && {productImageUrl: productImageUrl }),
            ...(productDescription !== rsGroup.productDescription && {productDescription: productDescription }),
            ...(priority !== receipt.priority && {priority: priority}),
            retailers: retailers.filter((r) => (r.checked && r.name !== 'Any')).map((r) => ({name: r.name})),
            upcs: upcs.map((upc) => ({upc: upc})),
            ...(fullStreetAddress !== rsGroup.fullStreetAddress && {fullStreetAddress: fullStreetAddress}),
            zips: zips.map((zip) => ({zip: zip}))
        }
        const requestData = {
            ...(name !== receipt.name && {name: name}),
            ...((!receipt.startDate || startDate.format('LL') !== moment.utc(receipt.startDate).format('LL')) && {startDate: this.state.startDate.add(this.state.startDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
            ...((!receipt.expirationDate || expirationDate.format('LL') !== moment.utc(receipt.expirationDate).format('LL')) && {expirationDate: this.state.expirationDate.add(this.state.expirationDate.utcOffset(), 'm').utc().startOf("day").valueOf()}),
             ...(budget !== receipt.budget && {budget: Number(budget)}),
            receiptScanGroupList: [rsGroupData],
            ...(isCreate && {status: 'DRAFT'})
        }
        this.setState({isUpdating: true, error: null});
            if (this.props.isCreate) {
                this.props.createReceiptLineup({
                    agencyId: agencyId,
                    brandId: brandId,
                    ...requestData
                })
                    // .then((res)=>res.instance.id)
                    .then((res) => {
                        return loadReceiptLineups()
                        .then(() => {
                            this.props.history.replace(`${this.getBackLink()}/${res.instance.id}`);
                            // window.location.reload();
                        })
                    })
                    .then((res) => this.handleSuccess())
                    // .then(() => this.componentWillMount())
                    .catch((err) => this.handleFailure(err));
            } else {
                this.props.updateReceiptLineup(this.props.receipt.id, requestData)
                    .then((res) => this.handleSuccess())
                    .catch((err) => this.handleFailure(err));
            }
    }

    onActivateClick(){
        this.setState({isActivating: true, error: null});
        this.props.updateReceiptLineup(this.props.receipt.id, {status: 'ACTIVE'})
            .then((res) => this.props.history.push(this.getBackLink(), {needUpdateLineUps: true}))
            // .then((res) => this.setState({status: 'active', isActivating: false}))
            .catch((err) => {
                try {
                    this.handleFailure(JSON.parse(err.message.replace(/'/g, '"')))
                } catch (e) {
                    this.handleFailure({message: err.message.replace(/'/g, '"')})
                }
            });
    }

    handleSuccess() {
        this.setState({isUpdating: false, isActivating: false});
    }

    handleFailure(err) {
        this.setState({error: err, isUpdating: false, isActivating: false});
    }

    getSubmitText() {
        if (this.state.isUpdating && this.props.isCreate) {
            return 'Creating';
        } else if (this.state.isUpdating) {
            return 'Updating';
        } else if (this.props.isCreate) {
            return 'Create';
        } else {
            return 'Update';
        }
    }

    getBackLink() {
        return this.props.match.url.substring(0, this.props.match.url.lastIndexOf('/'));
    }

    render() {
        const {
            isCreate,
            receipt,
            campaigns,
            giftCards
        } = this.props;
        const {
            name,
            groupName,
            startDate,
            expirationDate,
            budget,
            priority,
            split,
            costPerCompletion,
            rewardType,
            giftCardId,
            giftCardAmount,
            giftCardColor,
            giftCardColorValid,
            valuePerUser,
            threshold,
            creditType,
            maxTotal,
            maxPerUser,
            productImageUrl,
            productDescription,
            status,
            retailers,
            upcs,
            zips,
            fullStreetAddress
        } = this.state

        const {
            isUpdating,
            isActivating,
            upc,
            zip,
            campaignId,
            validateForm,
            error
        } = this.state;

        if (!isCreate && !receipt) {
            return <div>Verified Purchase failed to load</div>
        }
        const selectedRetailers = retailers.filter((r) => r.checked).map((r) => r.name)
        return (
            <Container className="EditVerifiedPurchase">
                <Row>
                    <Col xs='10'>
                        <h3>{isCreate ? 'Create Verified Purchase' : `Edit ${receipt.name}`}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup row>
                                <Label for="name" sm={4}>Product Internal Name</Label>
                                <Col sm={8}>
                                    <Input name="name"
                                           id="name"
                                           defaultValue={name}
                                           onChange={(e) => this.handleNameChange(e.target.value)}
                                           invalid={(!name || name.length === 0) && validateForm}/>
                                    {(!name || name.length === 0) && <FormFeedback>Product Internal Name is required</FormFeedback> }
                                    <FormText>Product internal name that is used for the reporting</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="groupName" sm={4}>Product Description</Label>
                                <Col sm={8}>
                                    <Input name="groupName"
                                           id="groupName"
                                           defaultValue={groupName}
                                           onChange={(e) => this.handleGroupNameChange(e.target.value)}
                                           invalid={(!groupName || groupName.length === 0) && validateForm}/>
                                    {(!name || name.length === 0) && <FormFeedback>Product Description is required</FormFeedback> }
                                    <FormText>Short name of product, included in List view</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="productDescription" sm={4}>Product Promotional Copy</Label>
                                <Col sm={8}>
                                    <Input name="productDescription"
                                           id="productDescription"
                                           defaultValue={productDescription}
                                           onChange={(e) => this.setState({ productDescription: e.target.value})}
                                           invalid={(!productDescription || productDescription.length === 0) && validateForm}
                                           placeholder='Enter a product promotional copy'/>
                                    <FormFeedback>Product Promotional Copy is required</FormFeedback>
                                    <FormText>Product Description that is shown on product details view</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="productImageUrl" sm={4}>Product Image</Label>
                                <Col sm={8}>
                                    <DroppableFileInput
                                        id='productImageUrl'
                                        text='Product Image'
                                        fileType='image'
                                        onChange={(image) => this.handleProductImageChange(image)}
                                        cropperAspectRatio={1}
                                        existingFileName={productImageUrl ? productImageUrl.split('/').pop(): ''}
                                        existingFileURL={productImageUrl}
                                        warning={ productImageUrl || !validateForm ? '' : 'Product image is required'}
                                    />
                                    <Row><Col sm={12}><FormText>Product image that is presented to the user.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="campaignId" sm={4}>Associated to Experience?</Label>
                                <Col sm={8}>
                                    <Input type='select'
                                           name='campaignId'
                                           defaultValue={campaignId}
                                           onChange={(e) => this.handleCampaignChange(e.target.value)}>
                                        <option key='' value=''>Not Selected</option>
                                        {campaigns.map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {this.getCampaignTitle(c)}
                                            </option>
                                        ))}
                                    </Input>
                                    <FormText>Should this be linked to an Experience?</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="budget" sm={4}>Budget ($$)</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="budget"
                                           id="budget"
                                           defaultValue={budget}
                                           invalid={(!budget || Number(budget) * 1000 < Number(costPerCompletion)) && validateForm}
                                           onChange={(e) => this.handleBudgetChange(e.target.value)}/>
                                    <FormFeedback>{!budget ? "Budget is required" : "Budget should be not less than cost per completion"}</FormFeedback>
                                    <FormText>Total amount allocated to Verified Purchase promotion</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="rewardType" sm={4}>Reward Type</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="rewardType"
                                                 id='rewardType'
                                                 defaultValue={rewardType}
                                                 invalid={(!rewardType || rewardType.length === 0) && validateForm}
                                                 onChange={(e) => this.setState({ rewardType: e.target.value})}>
                                        <option key='POINTS' value='POINTS'>Points</option>
                                        <option key='GIFTCARD' value='GIFTCARD'>Gift Card</option>
                                    </CustomInput>
                                    <FormText>User gets either Points or Gift Card for completion.</FormText>
                                </Col>
                            </FormGroup>
                            {rewardType === 'POINTS' &&
                            <FormGroup row>
                                <Label for="costPerCompletion" sm={4}>Cost per completion (pts)</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="costPerCompletion"
                                           id="costPerCompletion"
                                           defaultValue={costPerCompletion}
                                           invalid={(!costPerCompletion || Number(costPerCompletion) < 1 || Number(costPerCompletion) > 10000) && validateForm}
                                           onChange={(e) => this.handleCostPerCompletionChange(e.target.value)}/>
                                    <FormFeedback>{"Cost per completion should be between 1 and 10000"}</FormFeedback>
                                    <FormText>Cost per user completion</FormText>
                                </Col>
                            </FormGroup>
                            }
                            {rewardType === 'POINTS' &&
                            <FormGroup row>
                                <Label for="split" sm={4}>Split (%)</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="split"
                                           id="split"
                                           defaultValue={split}
                                           invalid={(!split || Number(split) < 1 || Number(split) > 100) && validateForm}
                                           onChange={(e) => this.handleSplitChange(e.target.value)}/>
                                    <FormFeedback>{"Split should be between 1 and 100"}</FormFeedback>
                                    <FormText>% to user; default is 100% of budget to user</FormText>
                                </Col>
                            </FormGroup>
                            }
                            {rewardType === 'POINTS' &&
                            <FormGroup row>
                                <Label for="valuePerUser" sm={4}>User Gets (pts)</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="valuePerUser"
                                           id="valuePerUser"
                                           disabled={true}
                                           value={valuePerUser}
                                           invalid={(!valuePerUser || Number(valuePerUser) < 1 || Number(valuePerUser) > 10000) && validateForm}/>
                                    <FormFeedback>{"Value should be between 1 and 10000"}</FormFeedback>
                                    <FormText>Cost per user completion</FormText>
                                </Col>
                            </FormGroup>
                            }
                            {rewardType === 'GIFTCARD' &&
                            <FormGroup row>
                                <Label for="giftCardId" sm={4}>Gift Card</Label>
                                <Col sm={8}>
                                    <Input type='select'
                                           name='giftCardId'
                                           defaultValue={giftCardId}
                                           invalid={!giftCardId && validateForm}
                                           onChange={(e) => this.handleGiftCardChange(e.target.value)}>
                                        <option key='' value=''>Not Selected</option>
                                        {giftCards.map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {this.getCardTitle(c)}
                                            </option>
                                        ))}
                                    </Input>
                                    <FormFeedback>Gift Card is required</FormFeedback>
                                    <FormText>What gift card user gets on completion?</FormText>
                                </Col>
                            </FormGroup>
                            }
                            { rewardType === 'GIFTCARD' &&
                            <FormGroup row>
                                <Label for="giftCardAmount" sm={4}>Denomination</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="giftCardAmount"
                                           id="giftCardAmount"
                                           defaultValue={giftCardAmount}
                                           step="any"
                                           onChange={(e) => this.handleCardAmountChange(e.target.value)}
                                           invalid={!this.isCardAmountValid() && validateForm}
                                           placeholder="value in range of selected gift card"/>
                                    <FormFeedback>{giftCardAmount ? `Denomination should be in range of ${this.getCardTitle(this.state.giftCard)}` : "Denomination shouldn't be empty"}</FormFeedback>
                                    <FormText>Pick gift card denomination</FormText>
                                </Col>
                            </FormGroup>
                            }
                            { rewardType === 'GIFTCARD' &&
                            <FormGroup color={giftCardColorValid ? '' : 'danger'} row>
                                <Label for='giftCardColor' sm={4}>Button Color</Label>
                                <Col sm={8}>
                                    <ColorInput
                                        id='giftCardColor'
                                        name='giftCardColor'
                                        defaultValue={giftCardColor}
                                        placeholder='#FF00FF'
                                        onChange={this.handleColorChange.bind(this)}
                                    />
                                    {!giftCardColorValid && validateForm &&
                                    <FormText color='danger'>Color is required</FormText>
                                    }
                                    <Row><Col sm={12}><FormText>Backgroud color for the button with gift card name and denomination</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            }
                            <FormGroup row>
                                <Label for="creditType" sm={4}>Threshold Type</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="creditType"
                                                 id='creditType'
                                                 defaultValue={creditType}
                                                 invalid={(!creditType || creditType.length === 0) && validateForm}
                                                 onChange={(e) => this.setState({ creditType: e.target.value})}>
                                        <option key='COUNT_THRESHOLD' value='COUNT_THRESHOLD'>Items Count</option>
                                        <option key='AMOUNT_THRESHOLD' value='AMOUNT_THRESHOLD'>Dollar Amount</option>
                                    </CustomInput>
                                    <FormText>'Items Count' requires that a number of promoted items are purchased; 'Dollar Amount' requires a minimum spend in promoted items.</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="threshold" sm={4}>Threshold</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="threshold"
                                           id="threshold"
                                           value={threshold}
                                           onChange={(e) => this.setState({ threshold: Number(e.target.value)})}
                                           invalid={(!threshold || threshold <= 0 ||
                                               (creditType === 'count' && !Number.isInteger(threshold)
                                                   || creditType === 'amount')) && validateForm}/>
                                    <FormFeedback>{"Value should be integer and greater than zero"}</FormFeedback>
                                    <FormText>{creditType === 'count' ? 'Quantity - in items or dollars - of promoted products required to get the credit' : 'Quantity - in items or dollars - of promoted products required to get the credit'}</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="maxPerUser" sm={4}>Weekly Credit Max (# of Credits)</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="maxPerUser"
                                           id="maxPerUser"
                                           value={maxPerUser}
                                           onChange={(e) => this.setState({ maxPerUser: Number(e.target.value)})}
                                           invalid={(!maxPerUser || maxPerUser < 1 || !Number.isInteger(maxPerUser)) && validateForm}/>
                                    <FormFeedback>{"Value should be integer and greater than zero"}</FormFeedback>
                                    <FormText>Limit how many credits are rewarded to a user for a promoted item.  This may vary based on purchase cycle of item(s)</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="maxTotal" sm={4}>Total Credit Max (# of Credits)</Label>
                                <Col sm={8}>
                                    <Input type="number"
                                           name="maxTotal"
                                           id="maxTotal"
                                           value={maxTotal}
                                           onChange={(e) => this.setState({ maxTotal: Number(e.target.value)})}
                                           invalid={(!maxTotal || maxTotal < 1 || !Number.isInteger(maxTotal)) && validateForm}/>
                                    <FormFeedback>{"Value should be integer and greater than zero"}</FormFeedback>
                                    <FormText>Limit how many times this promotion is available to user.</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='startDate'>Start Date</Label>
                                <Col sm={8}>
                                    <DateInput id='startDate'
                                               className='form-control'
                                               minDate={moment().startOf("day")}
                                               selected={startDate}
                                               onChange={(d) => this.setState({startDate: d})}
                                    />
                                    <FormFeedback>Incorrect Date</FormFeedback>
                                    <Row><Col sm={12}><FormText>When should the verified purchase opportunity start?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='expirationDate'>Expiration Date</Label>
                                <Col sm={8}>
                                    <DateInput id='expirationDate'
                                               className='form-control'
                                               disabled={!startDate}
                                               minDate={startDate || moment().startOf("day")}
                                               selected={expirationDate}
                                               onChange={(d) => {
                                                   this.setState({expirationDate: d});
                                               } }
                                    />
                                    {startDate >= expirationDate && validateForm &&
                                    <FormText color='danger'>Expiration date should be greater than start date</FormText>
                                    }
                                    <Row><Col sm={12}><FormText sm={12}>When should the verified purchase opportunity expire?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="selectPriority" sm={4}>Priority</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="selectPriority"
                                                 id='selectPriority'
                                                 defaultValue={priority}
                                                 invalid={(!priority || priority.length === 0) && validateForm}
                                                 onChange={(e) => this.setState({ priority: Number(e.target.value)})}>
                                        {[1,2,3,4,5,6,7,8,9].map((i) => (
                                            <option key={i} value={i}>{i}</option>
                                        ))}
                                    </CustomInput>
                                    <FormFeedback>Priority is required</FormFeedback>
                                    <Row><Col sm={12}><FormText>Priority defines sorting order for the user.</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="retailers" sm={4}>Choose Retailers</Label>
                                <Col sm={8}>
                                    <Label for="retailers_upload" className="btn">Upload Retailers</Label>
                                    <Input type="file" name="file" id="retailers_upload" accept='.csv'
                                           onChange={(e) => this.handleFileUploadChange(e, (result => {
                                               let uploadedRetailers = result.split(/[,(\r?\n)\n]/).filter((item) => (item !== ''))
                                               if (!uploadedRetailers || uploadedRetailers.length === 0){
                                                   return
                                               }
                                               this.setState({retailers: unionBy(uploadedRetailers.map(r => ({name: r, checked: true })), this.state.retailers.map(r => (r.name === 'Any' ? {name: 'Any', checked : false} : r)), 'name')})
                                           }))}
                                           style={{display: 'none'}}/>
                                    <FormFeedback>Retailer selection is required</FormFeedback>
                                    <Row><Col sm={12}><FormText>At what retailer(s) should the promoted products be purchased?  If there are no specific retailers required, choose 'Any'.</FormText></Col></Row>
                                </Col>
                                <Col sm={{size:8, offset: 4}}>
                                    <Row id="retailers">
                                        {retailers.map((r) => (
                                        <Col xs="auto" key={r.name + r.checked}>
                                            <CustomInput type="switch" id={r.name} name={r.name} label={r.name} defaultChecked={r.checked} onChange={(e) => this.handleRetailerSwitchChange(e)}/>
                                        </Col>
                                    ))}
                                    </Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="upcs" sm={4}>UPC or Product Numbers (ASIN) List</Label>
                                <Col sm={8}>
                                    <Label for="upcs_upload" className="btn">Upload List</Label>
                                    <Input type="file" name="file" id="upcs_upload" accept='.csv'
                                           onChange={(e) => this.handleFileUploadChange(e, (result => this.setState({upcs: result.split(/[,(\r?\n)\n]/).map((upc) => (this.adjustUpc(upc))).filter((upc) => (upc !== ''))})))}
                                           style={{display: 'none'}}/>
                                    <Button2 color="link" onClick={(e) => this.clearUpcs(e)}> Clear Upcs</Button2>
                                    <Input placeholder="Enter UPC or ASIN"
                                           value={upc}
                                           invalid={!(upcs.length > 0 || upcs.length === 0 && creditType === 'AMOUNT_THRESHOLD' && selectedRetailers.length > 0 && selectedRetailers[0] !== 'Any')}
                                           onKeyPress={(e) => (this.handleUpcSubmitted(e))}
                                           onChange={(e) => (this.handleUpcChange(e))}/>
                                    <FormFeedback>If no products selected, then at least one Retailer should be selected and 'Dollar Amount' Threshold type</FormFeedback>
                                    <Row><Col sm={12}><FormText>Upload file in .csv format, all values with 10 alphanumeric characters (ASIN) or with 11 or 12 digits (UPC) will be processed.</FormText></Col></Row>
                                </Col>
                                <Col sm={{size:8, offset: 4}}>
                                    <Row id="upcs">
                                        {upcs.map((upc) => (
                                        <Col xs="auto" key={upc}>
                                            <span> {upc} </span>
                                            <button type="button" className="close" aria-label="Close" onClick={() => this.handleUpcDelete(upc)} >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </Col>
                                            ))}
                                    </Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="zips" sm={4}>Zip Codes</Label>
                                <Col sm={8}>
                                    <Input placeholder="Enter zip code"
                                           value={zip}
                                           onKeyPress={(e) => (this.handleZipSubmitted(e))}
                                           onChange={(e) => (this.handleZipChange(e))}/>
                                    <Row><Col sm={12}><FormText>Enter 5 digit zip code.</FormText></Col></Row>
                                </Col>
                                <Col sm={{size:8, offset: 4}}>
                                    <Row id="zips">
                                        {zips.map((zip) => (
                                            <Col xs="auto">
                                                <span> {zip} </span>
                                                <button type="button" className="close" aria-label="Close" onClick={() => this.handleZipDelete(zip)} >
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </Col>
                                        ))}
                                    </Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="fullStreetAddress" sm={4}>Full Street address</Label>
                                <Col sm={8}>
                                    <Input name="fullStreetAddress"
                                           id="fullStreetAddress"
                                           defaultValue={fullStreetAddress}
                                           onChange={(e) => this.setState({ fullStreetAddress: e.target.value})}
                                           placeholder='Enter a full street address'/>
                                    <FormText>Full Street address - as expected on receipt </FormText>
                                </Col>
                            </FormGroup>
                            <br/>
                            {error &&
                                <div>
                                    { Object.entries(error).map(([key, value]) => <FormText color='danger' key={value}>{value}</FormText>)}
                                    <br/>
                                </div>
                            }
                            <div>
                                <Button isSubmit disabled={isUpdating}>{this.getSubmitText()}</Button>
                                { status === 'DRAFT' &&
                                    <Button className='ml-2' disabled={isUpdating || isActivating || !this.isValidReceipt()}
                                            onClick={() => this.onActivateClick()}>{this.state.isActivating ? 'Activating...' : 'Activate'}</Button>
                                }
                                <Button
                                    linkHref={this.getBackLink()}
                                    className='float-right'
                                    textColor='#666666'
                                    borderColor='#cccccc'
                                    backgroundColor='#ededed'> Cancel </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default EditVerifiedPurchase;



// WEBPACK FOOTER //
// ./src/routes/EditVerifiedPurchase/components/EditVerifiedPurchase.js